import { colors } from '@lmc/common/constants'
import { Icon } from '@lmc/ui-kit'
import type React from 'react'
import styled from 'styled-components'
import TextField from '../../../fields/types/TextField'

interface EmarCustomMedNameFieldProps {
  onCancel: () => void
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  values: Record<string, any>
  testId?: string
}

export default function EmarCustomMedNameField(
  props: EmarCustomMedNameFieldProps
): JSX.Element {
  const { onCancel, onChange, values, testId } = props

  return (
    <FieldSubContainer
      data-testid={
        testId ? `${testId}-custom-med-name-field` : 'custom-med-name-field'
      }
    >
      {/* @ts-ignore */}
      <TextField
        formKey="medicationName"
        layout="no-label"
        onChange={onChange}
        values={values}
        data-testid={
          testId ? `${testId}-custom-med-name-input` : 'custom-med-name-input'
        }
      />
      <CancelContainer
        id="cancelContainer"
        onClick={onCancel}
        data-testid={
          testId ? `${testId}-custom-med-name-cancel` : 'custom-med-name-cancel'
        }
      >
        {/* @ts-ignore */}
        <Icon name="CloseOutlined" style={{ fontSize: 15 }} />
      </CancelContainer>
    </FieldSubContainer>
  )
}

const CancelContainer = styled.div`
  cursor: pointer;
  margin: 0px 8px 0px 16px;

  &:hover {
    color: ${colors.red};
  }
`

const FieldSubContainer = styled.div`
  align-items: center;
  background: ${colors.white};
  display: flex;
  margin-top: 10px;
`
